module.exports = __webpack_public_path__ + "img/one.6465c1d7.jpg";